import { Skeleton } from "antd-mobile";
import { homeAtom } from "@/atoms/home";
import BaseWeather from "./BaseWeather";

const SKELETON_STYLES = {
  current2: { "--width": "100%", "--height": "233px", "--border-radius": "10px" },
};

const CurrentWeatherSection: React.FC<any> = () => {
  const homeData = useAtomValue(homeAtom);
  const current = homeData?.data?.current ?? {};
  if (isEmptyType(current)) {
    return <Skeleton animated style={SKELETON_STYLES.current2} />;
  }

  return <BaseWeather />;
};

export default CurrentWeatherSection;
